module.exports = __webpack_public_path__ + "static/media/signage-indoor-img17.883398d8.jpg";